<template>
  <button
    ref="cncButton"
    type="button"
    :class="`cnc-button ${sizeButton[size]} ${loading ? typeStyle[type].loadingClassName : typeStyle[type].className}`"
    :style="`width: ${getWidth()}`"
    :disabled="loading || disabled"
    :data-qa="`${qa ? `btn-${qa}` : 'btn'}`"
    @mouseover="isHover = true"
    @mouseout="isHover = false"
    @click="$emit('click')"
  >
    <CncIcon
      v-if="loading"
      class="icon-loading"
      name="IconLoading"
      :color="getColorSvgIcon()"
    />
    <div
      v-if="leftIcon && !loading"
      class="icon-left"
    >
      <CncIcon
        v-if="leftIcon"
        :name="leftIcon.name"
        :color="getColorSvgIcon()"
        :color2="typeStyle[type].color2"
        :isTwoTone="leftIcon.isTwoTone"
        :isSolid="leftIcon.isSolid"
        :width="iconWidth"
      />
    </div>
    <span
      v-if="(name && name.length) && trimmedNameText"
      class="txt-button"
    >{{ trimmedNameText }}</span>
    <slot v-else />
    <div
      v-if="rightIcon && !loading"
      class="icon-right"
    >
      <CncIcon
        v-if="rightIcon"
        :name="rightIcon.name"
        :color="getColorSvgIcon()"
        :color2="typeStyle[type].color2"
        :isTwoTone="rightIcon.isTwoTone"
        :isSolid="rightIcon.isSolid"
        :width="iconWidth"
      />
    </div>
    <CncBadgeNumber
      v-if="badgeNumber && !loading"
      :number="badgeNumber"
      :size="sizeBadgeNumber[size]"
      :isAbbreviated="isAbbreviated"
    />
  </button>
</template>

<script>
export default {
  props: {
    name: { type: String },
    disabled: { type: Boolean },
    type: { type: String, default: 'filled' },
    typeWidth: { type: String, default: 'hug' },
    size: { type: String, default: 'large' },
    loading: { type: Boolean },
    leftIcon: { type: Object },
    rightIcon: { type: Object },
    width: { type: Number },
    badgeNumber: { type: Number },
    isAbbreviated: { type: Boolean },
    qa: { type: String }
  },
  data () {
    return {
      typeStyle: {
        'filled': {
          className: 'button-filled',
          loadingClassName: 'button-filled-loading',
          color: '#fff',
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: '#fff',
          color2: this.$store.state.color['primary-200']
        },
        'tonal': {
          className: 'button-tonal',
          loadingClassName: 'button-tonal-loading',
          color: this.$store.state.color['primary-500'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['primary-500'],
          color2: this.$store.state.color['primary-200']
        },
        'tonal-outlined': {
          className: 'button-tonal-outlined',
          loadingClassName: 'button-tonal-outlined-loading',
          color: this.$store.state.color['primary-500'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['primary-500'],
          color2: this.$store.state.color['primary-200']
        },
        'tonal-alt': {
          className: 'button-tonal-alt',
          loadingClassName: 'button-tonal-alt-loading',
          color: this.$store.state.color['secondary-500'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['secondary-500'],
          color2: this.$store.state.color['secondary-200']
        },
        'tonal-alt-outlined': {
          className: 'button-tonal-alt-outlined',
          loadingClassName: 'button-tonal-alt-outlined-loading',
          color: this.$store.state.color['secondary-500'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['secondary-500'],
          color2: this.$store.state.color['secondary-200']
        },
        'neutral': {
          className: 'button-neutral',
          loadingClassName: 'button-neutral-loading',
          color: this.$store.state.color['coolGrey-700'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['coolGrey-700'],
          color2: this.$store.state.color['coolGrey-200']
        },
        'neutral-outlined': {
          className: 'button-neutral-outlined',
          loadingClassName: 'button-neutral-outlined-loading',
          color: this.$store.state.color['coolGrey-600'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['coolGrey-600'],
          color2: this.$store.state.color['coolGrey-200']
        },
        'ghost': {
          className: 'button-ghost',
          loadingClassName: 'button-ghost-loading',
          color: this.$store.state.color['coolGrey-700'],
          disabledColor: this.$store.state.color['coolGrey-300'],
          hoverColor: this.$store.state.color['coolGrey-700'],
          color2: this.$store.state.color['coolGrey-200']
        },
        'filled-on-color': {
          className: 'button-filled-on-color',
          loadingClassName: 'button-filled-on-color-loading',
          color: this.$store.state.color['primary-500'],
          disabledColor: '#fff',
          hoverColor: this.$store.state.color['primary-500'],
          color2: this.$store.state.color['primary-200']
        },
        'outline-on-color': {
          className: 'button-outline-on-color',
          loadingClassName: 'button-outline-on-color-loading',
          color: '#fff',
          disabledColor: '#fff',
          hoverColor: this.$store.state.color['primary-500'],
          color2: this.$store.state.color['primary-200']
        }
      },
      sizeButton: {
        'large': 'button-large',
        'medium': 'button-medium',
        'small': 'button-small'
      },
      sizeBadgeNumber: {
        'large': 'medium',
        'medium': 'small',
        'small': 'extra-small'
      },
      isHover: false
    }
  },
  computed: {
    trimmedNameText () {
      if (this.name.length && this.name.length > 24 && this.typeWidth === 'hug') return this.name.slice(0, 21) + '...'
      return this.name
    },
    iconWidth () {
      return this.size === 'large' ? 24 : this.size === 'medium' ? 24 : this.size === 'small' ? 20 : 20
    }
  },
  methods: {
    getWidth () {
      switch (this.typeWidth) {
        case 'hug': return 'auto'
        case 'fixed': return `${this.width}px`
        case 'fill': return '100%'
      }
    },
    getColorSvgIcon () {
      if (this.disabled) return this.typeStyle[this.type].disabledColor
      else if (this.isHover) return this.typeStyle[this.type].hoverColor
      else return this.typeStyle[this.type].color
    }
  }
}
</script>

<style lang="scss">
.cnc-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border-style: solid;
  border-width: 1px;
  border-color: transparent;
  line-height: 130%;
  white-space: nowrap;
  max-width: 100%;
  gap: 8px;

  span.txt-button {
    // overflow: hidden;
    text-overflow: ellipsis;
  }

  .icon-left,
  .icon-right,
  .cnc-badge-number {
    display: inline-block;
  }

  svg {
    width: 24px !important;
    height: 24px !important;
  }

  i {
    font-size: 2rem !important;
  }

  .icon-loading {
    animation-name: rotateAnimation;
    animation-duration: 2s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    @keyframes rotateAnimation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }

  &.button-large {
    padding: $space-xs $space-md;
    height: $space-3xl;
    font-size: 1.6rem;
  }

  &.button-medium {
    padding: $space-2xs $space-sm;
    height: $space-2xl;
    font-size: 1.4rem;
  }

  &.button-small {
    padding: $space-3xs $space-xs;
    height: $space-xl;
    font-size: 1.4rem;
    gap: 4px;

    svg {
      width: 20px !important;
      height: 20px !important;
    }

    i {
      font-size: 1.8rem !important;
    }
  }

  &.button-filled {
    color: $color-white;
    background-color: $color-primary-500;
    border-color: $color-primary-500;

    .cnc-badge-number {
      span.badge-number {
        color: $color-primary-500;
        background-color: $color-white;
        border-color: $color-white;
      }
    }

    &:hover {
      color: $color-white;
      background-color: $color-primary-600;
      border-color: $color-primary-600;
    }

    &:focus-visible {
      color: $color-white;
      background-color: $color-primary-500;
      border-color: $color-primary-500;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-white;
        background-color: $color-primary-600;
        border-color: $color-primary-600;
      }
    }

    &:active {
      color: $color-white;
      background-color: $color-primary-700;
      border-color: $color-primary-700;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-filled-loading {
    &:disabled {
      color: $color-white;
      background-color: $color-primary-500;
      border-color: $color-primary-500;
    }
  }

  &.button-tonal {
    color: $color-primary-500;
    background-color: $color-primary-50;
    border-color: $color-primary-50;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-primary-500;
        border-color: $color-primary-500;
      }
    }

    &:hover {
      color: $color-primary-500;
      background-color: $color-primary-100;
      border-color: $color-primary-100;
    }

    &:focus-visible {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border-color: $color-primary-50;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-primary-500;
        background-color: $color-primary-100;
        border-color: $color-primary-100;
      }
    }

    &:active {
      color: $color-primary-500;
      background-color: $color-primary-200;
      border-color: $color-primary-200;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-tonal-loading {
    &:disabled {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border-color: $color-primary-50;
    }
  }

  &.button-tonal-outlined {
    color: $color-primary-500;
    background-color: $color-primary-50;
    border-color: $color-primary-50;
    border: 1px solid $color-primary-200;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-primary-500;
        border-color: $color-primary-500;
      }
    }

    &:hover {
      color: $color-primary-500;
      background-color: $color-primary-100;
      border-color: $color-primary-100;
      border: 1px solid $color-primary-200;
    }

    &:focus-visible {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border-color: $color-primary-50;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;
      border: 1px solid $color-primary-200;

      &:hover {
        color: $color-primary-500;
        background-color: $color-primary-100;
        border-color: $color-primary-100;
        border: 1px solid $color-primary-200;
      }
    }

    &:active {
      color: $color-primary-500;
      background-color: $color-primary-200;
      border-color: $color-primary-200;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-tonal-outlined-loading {
    &:disabled {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border-color: $color-primary-50;
    }
  }

  &.button-tonal-alt {
    color: $color-secondary-500;
    background-color: $color-secondary-50;
    border-color: $color-secondary-50;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-secondary-500;
        border-color: $color-secondary-500;
      }
    }

    &:hover {
      color: $color-secondary-500;
      background-color: $color-secondary-100;
      border-color: $color-secondary-100;
    }

    &:focus-visible {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border-color: $color-secondary-50;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-secondary-500;
        background-color: $color-secondary-100;
        border-color: $color-secondary-100;
      }
    }

    &:active {
      color: $color-secondary-500;
      background-color: $color-secondary-200;
      border-color: $color-secondary-200;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-tonal-alt-loading {
    &:disabled {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border-color: $color-secondary-50;
    }
  }

  &.button-tonal-alt-outlined {
    color: $color-secondary-500;
    background-color: $color-secondary-50;
    border-color: $color-secondary-50;
    border: 1px solid $color-secondary-200;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-secondary-500;
        border-color: $color-secondary-500;
      }
    }

    &:hover {
      color: $color-secondary-500;
      background-color: $color-secondary-100;
      border-color: $color-secondary-100;
      border: 1px solid $color-secondary-200;
    }

    &:focus-visible {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border-color: $color-secondary-50;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;
      border: 1px solid $color-secondary-200;

      &:hover {
        color: $color-secondary-500;
        background-color: $color-secondary-100;
        border-color: $color-secondary-100;
        border: 1px solid $color-secondary-200;
      }
    }

    &:active {
      color: $color-secondary-500;
      background-color: $color-secondary-200;
      border-color: $color-secondary-200;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-tonal-alt-outlined-loading {
    &:disabled {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border-color: $color-secondary-50;
      border: 1px solid $color-secondary-200;
    }
  }

  &.button-neutral {
    color: $color-cool-grey-700;
    background-color: $color-cool-grey-100;
    border-color: $color-cool-grey-100;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-cool-grey-700;
        border-color: $color-cool-grey-700;
      }
    }

    &:hover {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-200;
      border-color: $color-cool-grey-200;
    }

    &:focus-visible {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-200;
        border-color: $color-cool-grey-200;
      }
    }

    &:active {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-300;
      border-color: $color-cool-grey-300;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-neutral-loading {
    &:disabled {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
    }
  }

  &.button-neutral-outlined {
    color: $color-cool-grey-700;
    background-color: $color-cool-grey-100;
    border-color: $color-cool-grey-100;
    border: 1px solid $color-cool-grey-200;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-cool-grey-700;
        border-color: $color-cool-grey-700;
      }
    }

    &:hover {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-200;
      border-color: $color-cool-grey-200;
      border: 1px solid $color-cool-grey-200;
    }

    &:focus-visible {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;
      border: 1px solid $color-cool-grey-200;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-200;
        border-color: $color-cool-grey-200;
        border: 1px solid $color-cool-grey-200;
      }
    }

    &:active {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-300;
      border-color: $color-cool-grey-300;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-cool-grey-300;
          border-color: $color-cool-grey-300;
        }
      }
    }
  }

  &.button-neutral-outlined-loading {
    &:disabled {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
      border: 1px solid $color-cool-grey-200;
    }
  }

  &.button-ghost {
    color: $color-cool-grey-700;
    background-color: transparent;
    border-color: transparent;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-cool-grey-700;
        border-color: $color-cool-grey-700;
      }
    }

    &:hover {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
    }

    &:focus-visible {
      color: $color-cool-grey-700;
      background-color: transparent;
      border-color: transparent;
      outline: $space-4xs solid $color-primary-200;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;
      }
    }

    &:active {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-200;
      border-color: $color-cool-grey-200;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: transparent;
      border-color: transparent;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-cool-grey-300;
          background-color: $color-cool-grey-100;
          border-color: $color-cool-grey-100;
        }
      }
    }
  }

  &.button-ghost-loading {
    &:disabled {
      color: $color-cool-grey-700;
      background-color: transparent;
      border-color: transparent;
    }
  }

  &.button-filled-on-color {
    color: $color-primary-500;
    background-color: $color-white;
    border-color: $color-white;

    .cnc-badge-number {
      span.badge-number {
        color: $color-white;
        background-color: $color-primary-500;
        border-color: $color-primary-500;
      }
    }

    &:hover {
      color: $color-primary-500;
      background-color: $color-cool-grey-50;
      border-color: $color-cool-grey-50;
    }

    &:focus-visible {
      color: $color-primary-500;
      background-color: $color-white;
      border-color: $color-white;
      outline: $space-4xs solid $color-white;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-primary-500;
        background-color: $color-cool-grey-50;
        border-color: $color-cool-grey-50;
      }
    }

    &:active {
      color: $color-primary-500;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;
    }

    &:disabled {
      color: $color-cool-grey-300;
      background: rgba(255, 255, 255, 0.2);
      border-color: transparent;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: rgba(255, 255, 255, 0.4);
          background: rgba(255, 255, 255, 0.2);
          border-color: none
        }
      }
    }
  }

  &.button-filled-on-color-loading {
    &:disabled {
      color: $color-primary-500;
      background-color: $color-white;
      border-color: $color-white;
    }
  }

  &.button-outline-on-color {
    color: $color-white;
    background-color: transparent;
    border-color: $color-white;

    .cnc-badge-number {
      span.badge-number {
        color: $color-primary-500;
        background-color: $color-white;
        border-color: $color-white;
      }
    }

    &:hover {
      color: $color-primary-500;
      background-color: $color-white;
      border-color: $color-white;

      i,
      svg {
        color: $color-primary-500;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-primary-500;
          border-color: $color-primary-500;
        }
      }
    }

    &:focus-visible {
      color: $color-white;
      background-color: transparent;
      border-color: transparent;
      outline: $space-4xs solid $color-white;
      outline-offset: $space-4xs;

      &:hover {
        color: $color-primary-500;
        background-color: $color-white;
        border-color: $color-white;

        i,
        svg {
          color: $color-primary-500;
        }

        .cnc-badge-number {
          span.badge-number {
            color: $color-white;
            background-color: $color-primary-500;
            border-color: $color-primary-500;
          }
        }
      }
    }

    &:active {
      color: $color-primary-500;
      background-color: $color-cool-grey-50;
      border-color: $color-cool-grey-50;

      i,
      svg {
        color: $color-primary-500;
      }

      .cnc-badge-number {
        span.badge-number {
          color: $color-white;
          background-color: $color-primary-500;
          border-color: $color-primary-500;
        }
      }
    }

    &:disabled {
      color: $color-cool-grey-300;
      background-color: transparent;
      border-color: $color-cool-grey-300;

      i,
      svg {
        color: $color-cool-grey-300;
      }

      .cnc-badge-number {
        span.badge-number {
          color: rgba(255, 255, 255, 0.4);
          background: rgba(255, 255, 255, 0.2);
          border-color: none
        }
      }
    }
  }

  &.button-outline-on-color-loading {
    &:disabled {
      color: $color-white;
      background-color: transparent;
      border-color: $color-white;
    }
  }
}
</style>
